<div class="progress-bar-container">
  <div class="progress-bar-track">
    <div class="progress-bar-label" *ngIf="isQtdParcialZero">{{ label }}</div>
    <div class="progress-bar-fill" [style.width.%]="(quantidadeParcial / quantidadeTotal) * 100">
      <div class="progress-bar-label"*ngIf="!isQtdParcialZero" >{{ label }}</div>
    </div>
  </div>
</div>

